import { useEffect } from 'react';

import { Card, Form, Row } from 'antd';
import dayjs from 'dayjs';

import FormField from '@/components/FormField';
import formFields from '@/config/programs/biFormFields/result';

const BiRequestResult = ({ data }: { data: any }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      ...data,
      prior_pa_end_date: data.prior_pa_end_date
        ? dayjs(data.prior_pa_end_date).format('MM-DD-YYYY')
        : null,
      prior_pa_approval_date: data.prior_pa_approval_date
        ? dayjs(data.prior_pa_approval_date).format('MM-DD-YYYY')
        : null,
      medical_plan_facility_network_status: data.medical_plan_facility_network_status
        ? data.medical_plan_facility_network_status
        : null,
      medical_plan_policy_effective_date: data.medical_plan_policy_effective_date
        ? dayjs(data.medical_plan_policy_effective_date).format('MM-DD-YYYY')
        : null,
      medical_plan_policy_renewal_date: data.medical_plan_policy_renewal_date
        ? dayjs(data.medical_plan_policy_renewal_date).format('MM-DD-YYYY')
        : null,
      medical_plan_policy_end_date: data.medical_plan_policy_end_date
        ? dayjs(data.medical_plan_policy_end_date).format('MM-DD-YYYY')
        : null,
      facility_date_of_request: data.facility_date_of_request
        ? dayjs(data.facility_date_of_request).format('MM-DD-YYYY')
        : null,
      patient_dob: data.patient_dob ? dayjs(data.patient_dob).format('MM-DD-YYYY') : null,
      verified_at: data.verified_at ? dayjs(data.verified_at).format('MM-DD-YYYY') : null,
      created_at: data.created_at ? dayjs(data.created_at).format('MM-DD-YYYY') : null,
    });
  }, [data]);

  return (
    <>
      <Card className="my-10 bg-white print:my-0 print:border-none print:p-0">
        <Form form={form} layout="vertical" className="mt-6">
          {' '}
          <h2 className="text-xl md:text-3xl font-bold text-center mb-10">
            Benefits Investigation Summary Form
          </h2>
          {formFields.map((section) => (
            <div>
              <div
                className="bg-[#20419b] px-2 text-xl font-semibold uppercase text-white"
                style={{ backgroundColor: '#000' }}
              >
                {section.title}
              </div>
              <Row gutter={[16, 0]} className="mt-4">
                {section.fields.map((field) => (
                  <FormField readOnly key={field.name} field={field} />
                ))}
              </Row>
            </div>
          ))}
        </Form>
      </Card>
    </>
  );
};

export default BiRequestResult;
